export interface IChartSelect {
  value?: string;
  label?: string;
}

export enum BarsChartShowSelect {
  Average = 'average',
  Distribution = 'distribution',
}
